var React = require('react');
var ReactNative = require('react-native');
var Globals = require('./Globals');
var ModelConstants = require('./constants/ModelConstants');
var LinkingManager = require('./wrappers/LinkingManager');
var createReactClass = require('create-react-class');
var {
  View,
  StyleSheet,
  Platform,
  Image,
  TouchableOpacity
} = ReactNative;

var MK = require('./wrappers/react-native-material-kit-wrapper');

var {
  MKSpinner
} = MK;

var ReUpButton = require('./ReUpButton');

var GoToAppStoreButton = createReactClass(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      initialLayout : {},
      appStoreURL : null,
      playStoreURL : null,
    }
  },

  getInitialState : function()
  {
    return {
      showSpinner:false,
    }
  },

  componentDidMount : function()
  {
  },

  componentWillUnmount : function()
  {
  },

  goToStore : function()
  {
    var thisThing = this;
    this.setState({showSpinner:true});
    setTimeout(()=>
    {
      thisThing.setState({showSpinner:false});
    }, 5000);

    var phoneOS = this.props.appManager.getMobileOperatingSystem();
    if( phoneOS == "android" ) LinkingManager.openURL(this.props.playStoreURL);
    else LinkingManager.openURL(this.props.appStoreURL);
  },

  render: function()
  {
    if( this.props.appStoreURL == null || this.props.appStoreURL.length <= 0) return null;
    
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = this.props.appManager.getLocalizationManager();

    if( this.state.showSpinner)
    {
      return (
        <View ref={(c) => { this._ref_spinner = c; }} key="spinner" style={[this.props.style, {flexDirection:'column', justifyContent:'center', alignItems:'center'}]}>
          <MKSpinner strokeColor={[appManager.getColorForKey("HeaderTitleColor"), appManager.getColorForKey("HeaderColor")]} style={{alignSelf:'center'}}/>
        </View>
      )
    }

    var phoneOS = appManager.getMobileOperatingSystem();
    var imageURL = "https://devimages-cdn.apple.com/app-store/marketing/guidelines/images/badge-download-on-the-app-store.svg";
    if( phoneOS == "android" ) imageURL = "https://play.google.com/intl/en_us/badges/images/badge_new.png";

    return (
      <TouchableOpacity style={[this.props.style, {flexDirection:'column', cursor:'pointer', backgroundColor:'transparent'}]}
        onPress={()=> this.goToStore()}>
        <Image key={"store"} resizeMode={"contain"} source={{uri: imageURL}} style={{flex:1, alignSelf:'stretch'}}/>
      </TouchableOpacity>
    );
  }
});

module.exports = GoToAppStoreButton;
